// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","logo":"Header_logo__UsziS","fixed":"Header_fixed__kllSm","hero":"Header_hero__M6mFb"};